import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  declared: ['declared'],
  readTerms: ['read'],
});

export const DeclarationTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/DeclarationActions.js